import { render } from "./Article.vue?vue&type=template&id=ca9d3cf4"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
script.render = render

export default script